import { i18n } from '@lingui/core';
import { messages as fi } from './fi/messages_fi.js';
import { messages as en } from './en/messages_en.js';
import { messages as nb } from './nb/messages_nb.js';
import { messages as da } from './da/messages_da.js';
import { messages as sv } from './sv/messages_sv.js';

i18n.load({ nb, en, fi, da, sv });

export default i18n;
